'use strict';

/**
* Copyright (c) 2017 Copyright tj All Rights Reserved.
* Author: lipengxiang
* Date: 2018-06-02 17:39
* Desc: 
*/

var date = require('../common/date');

exports.isValidate    = date.isValidate;
exports.getDate       = date.getDate;
exports.getDate2      = date.getDate2;
exports.getDate2FromUTC   = date.getDate2FromUTC;
exports.getDateFromUTC    = date.getDateFromUTC;
exports.getTime2FromUTC   = date.getTime2FromUTC;
exports.getTimeString = date.getTimeString;
exports.getUTCTimeString = date.getUTCTimeString;
exports.getTimeStringFromNow  = date.getTimeStringFromNow;
exports.getTimeFromUTC    = date.getTimeFromUTC;
exports.getTime  = date.getTime;
exports.getTime2    = date.getTime2;
